import { IWhyNeedSdelkaItemProps } from '../../../components/WhyNeedSdelka/WhyNeedSdelkaItem';

import keySrc from '../../common/assets/Key.svg';
import walletSrc from '../../common/assets/Buyer.svg';

export const WHY_NEED_SDELKA_ITEMS: IWhyNeedSdelkaItemProps[] = [
  {
    icon: walletSrc,
    title: 'Продать без суеты',
    description: 'Мы сделаем всё: от подготовки объекта и продвижения до организации просмотров и безопасных расчётов',
  },
  {
    icon: keySrc,
    title: 'Купить без рисков',
    description:
      'Подберем варианты под ваш бюджет, возьмем на себя звонки и просмотры, позаботимся о вашей выгоде и обеспечим юридическую чистоту объекта',
  },
];
